import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { NavigationGuardBypassService } from './navigation-guard-bypass.service';

export interface CanComponentDeactivate {
  canDeactivate(): boolean;
}

export const canDeactivateGuard: CanDeactivateFn<CanComponentDeactivate> = (component) => {
  if (inject(NavigationGuardBypassService).consumeBypass()) return true;
  return component.canDeactivate();
};
